import { styled } from "@mui/material/styles";

// Components
import { Box, Typography } from "@mui/material";
import theme from "~/components/Common/Theme";

const styledName = "WalletInfoItem";

export const StyledItemWrapper = styled(Box, { name: styledName })({
  "&": {
    height: "0px",
    opacity: 0,
    borderBottom: `solid 2px ${theme.palette.grey[300]}`,
    display: "flex",
    alignItems: "center",
    width: "0px",
    animation: `growing 0.3s ease-in forwards`,
    "@keyframes growing": {
      from: { height: 0, width: 0, opacity: 0 },
      to: { height: "40px", width: "360px", opacity: 1 },
    },
  },
});

export const StyledItemLabel = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.6rem",
    color: theme.palette.grey[700],
    textAlign: "start",
    minWidth: "150px",
    marginRight: "10px",
  },
});
